var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#1488FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1616 8.78H11.8416V15.5H10.1616V8.78ZM9.92364 6.498C9.92364 6.22733 10.0216 5.994 10.2176 5.798C10.423 5.59267 10.6796 5.49 10.9876 5.49C11.2956 5.49 11.5523 5.588 11.7576 5.784C11.9723 5.97067 12.0796 6.20867 12.0796 6.498C12.0796 6.78733 11.9723 7.03 11.7576 7.226C11.5523 7.41267 11.2956 7.506 10.9876 7.506C10.6796 7.506 10.423 7.408 10.2176 7.212C10.0216 7.00667 9.92364 6.76867 9.92364 6.498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueInfo);
export default __webpack_public_path__ + "static/media/blueInfo.3d7900bdb61c76d13de22a47898db503.svg";
export { ForwardRef as ReactComponent };